import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ScheduleAction } from '@cbridge-packages/schedule';
import { detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { generateScheduleProfileRoute } from '@cbridge-packages/routing-client-admin';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeScheduleBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { scheduleId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (scheduleId === openedDetailsId) {
      return [
        RouterAction.replace([generateScheduleProfileRoute(), withSkipUnsavedChangesConfirmation()]),
      ];
    }

    return [];
  }),
);
